import React from 'react'
import { GlobalStyles, Stack } from '@mui/material'
import Logo from '../../assets/images/logo.svg?react'
import Brand from '../../assets/images/ninkasi.svg?react'
import Loading from '../../assets/images/loading.svg?react'
import merge from 'lodash/merge'
import { GLOBAL_MAX_WIDTH_STYLE } from '../../providers/ConfigProviders'

const LoadingPage = () => {
    return (
        <>
            <GlobalStyles
                styles={(theme) => ({
                    ...merge(GLOBAL_MAX_WIDTH_STYLE, {
                        body: {
                            backgroundColor: theme.palette.common.black,
                        },
                    }),
                })}
            />
            <Stack
                direction="column"
                spacing={4}
                sx={(theme) => ({
                    color: theme.palette.common.white,
                    height: '100vh',
                    alignItems: 'center',
                    justifyContent: 'center',
                })}
            >
                <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                    <Logo height={50} />
                    <Brand height={22} />
                </Stack>

                <Loading height={32} />
            </Stack>
        </>
    )
}

export default LoadingPage
